import { render, staticRenderFns } from "./PharmacyLicenseExpires.vue?vue&type=template&id=a21eee00&"
import script from "./PharmacyLicenseExpires.vue?vue&type=script&lang=ts&"
export * from "./PharmacyLicenseExpires.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports